import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_BRAND_CURATION_TASK_STATUS_FLAG_MUTATION } from '../graphql/mutations'
import { UPDATE_BRAND_CURATION_TASK_STATUS_FLAG } from '../redux/action-types'

const useUpdateBrandCurationTaskStatusFlagMutation = () => {
  const dispatch = useDispatch()

  const { isUpdateLoading: isLoading, updateError: error } = useSelector(
    store => store.brandCurationTasks.brandCurationTask,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate({
        mutation: UPDATE_BRAND_CURATION_TASK_STATUS_FLAG_MUTATION,
        variables: { id, data },
        dispatch,
        action: UPDATE_BRAND_CURATION_TASK_STATUS_FLAG,
      }),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateBrandCurationTaskStatusFlagMutation
